export const SELECT_INSTALLMENTS_NUMBER = Array.from(new Array(12)).map(
  (_, index) => {
    const indexToCardinal = index + 1
    return {
      name: indexToCardinal.toString(),
      value: indexToCardinal
    }
  }
)
